import { MinuteHeaderPanel } from 'components/minute/layout/MinuteHeaderPanel';
import { EColors } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export const MinuteHeaderLayout = (props: Props): JSX.Element => {
    return (
        <S_MinuteHeaderLayout className={props.className}>
            <MinuteHeaderPanel>{props.children}</MinuteHeaderPanel>
        </S_MinuteHeaderLayout>
    );
};

const S_MinuteHeaderLayout = styled.div`
    width: 100%;
    height: 50px;
    background-color: ${EColors.PRIM3};
    display: flex;
    flex-shrink: 0;
`;
